import React, {useCallback, useState} from 'react'
import styles from '../../../CSS/main.css'
import {Col} from '../List/Col'
import UserMenu from '../RightPanel/UserMenu'
import {User} from "../List/Item/CommentsItem";

type Props = {
  user: User
}

const UserBlock: React.VFC<Props> = ({user}) => {
  const [open, setOpen] = useState(false)
  const toggleMenu = useCallback(() => setOpen(!open), [open, setOpen])

  return (
    <Col additionalClassNames={[styles.NavProfile]}>
      <div
        className={styles.LinkProfile}
        title='Profile &amp; Settings'
        onClick={toggleMenu}>
        <div className={styles.ProfilePic}>
          <div
            className={styles.Avatar}
            style={{
              backgroundImage: `url(${user.avatar})`,
            }}
          />
          <span className={styles.Notification}/>
        </div>
        <div className={styles.ProfileName}>{user.name}</div>
      </div>
      <UserMenu open={open} onClose={toggleMenu} user={user}/>
    </Col>
  )
}

export default UserBlock
